import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import AuthProvider from './provider/AuthProvider';
import { BookmarkRefreshProvider } from './provider/BookmarkRefreshProvider';
import { ThemeModeProvider, useThemeMode } from './provider/ThemeProvider';
import Routes from './routes';
import ErrorBoundary from './components/ErrorBoundary';

import './App.css';
import '@fontsource/roboto/700.css';

const ThemedApp = () => {
    const { mode } = useThemeMode();

    const theme = createTheme({
        palette: {
            mode,
            primary: {
                light: '#757ce8',
                main: '#3f50b5',
                dark: '#002884',
                contrastText: '#fff',
            },
            secondary: {
                light: '#ff7961',
                main: '#f44336',
                dark: '#ba000d',
                contrastText: '#000',
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <BookmarkRefreshProvider>
                    <Routes />
                </BookmarkRefreshProvider>
            </AuthProvider>
        </ThemeProvider>
    );
};

function App() {
    return (
        <ErrorBoundary>
            <div className="App">
                <ThemeModeProvider>
                    <ThemedApp />
                </ThemeModeProvider>
            </div>
        </ErrorBoundary>
    );
}

export default App;
